import React from 'react'
import { getDateFromDateTimeToDisplay, sumArray } from '../../../Utils/helper'
import { exportFileToCsv } from '../../../Utils/excelHelper'
import { ExcelButton } from '../../../Buttons'

const YarnitemInwardReport = ({ inwardItems = [], dataObj, item }) => {
  const inwardItemsWithLot = [];
  inwardItems.forEach(i => {
    i.lotDetails.forEach(j => {
      inwardItemsWithLot.push({ docId: i?.ProcessInward?.docId, dcNo: i?.ProcessInward?.dcNo, dcDate: i?.ProcessInward?.dcDate, lotNo: j.lotNo, inwardBags: j.inwardBags, inwardQty: j.inwardQty });
    })
  })
  return (
    <div className='border bg-gray-200'>
      <div className='flex justify-between text-xl text-center'>
        <div>{dataObj.docId}</div>
        <div className=''>Inward Report</div>
      </div>
      <table className='table-fixed text-xs border border-gray-500 '>
        <thead>
          <tr className='table-row'>
            <th>Yarn</th>
            <th className='w-20 table-data'>Color</th>
            <th className='w-20 table-data'>Uom</th>
          </tr>
        </thead>
        <tbody>
          <tr className='table-row'>
            <td className='table-data'>
              {item.Yarn.aliasName}
            </td>
            <td className='table-data'>
              {item.Color.name}
            </td>
            <td className='table-data'>
              {item.Uom.name}
            </td>
            <td className='py-1 text-center w-8'>
              <ExcelButton onClick={() => {
                exportFileToCsv([
                  { "Po No.": item.docId, "Yarn": item.Yarn.aliasName, "Color": item.Color.name, "Uom": item.Uom.name }
                  , ...inwardItemsWithLot], `${item.docId}-Inward`)
              }} width={18} />
            </td>
          </tr>
        </tbody>
      </table>
      <table className='table-auto w-full text-xs border border-gray-500 '>
        <thead className=' border-b border-gray-500'>
          <tr className='bg-blue-200 border border-gray-500 sticky top-10 '>
            <th className="table-data  w-2 text-center">S.no</th>
            <th className="table-data  w-2 text-center">Inward No.</th>
            <th className="table-data  w-20 text-center">Inward Date.</th>
            <th className="table-data  w-20 text-center">DC No.</th>
            <th className="table-data  w-20 text-center">Dc Date.</th>
            <th className="table-data  w-10">Lot No.</th>
            <th className="table-data  w-10">Inward Bags</th>
            <th className="table-data  w-10">Inward Qty</th>
          </tr>
        </thead>
        <tbody>
          {inwardItemsWithLot.map((item, index) =>
            <tr key={item.id}>
              <td className='text-center   table-data'>{index + 1}</td>
              <td className='text-left  table-data'>{item?.docId}</td>
              <td className='text-left  table-data'>{getDateFromDateTimeToDisplay(item?.createdAt)}</td>
              <td className='text-left  table-data'>{item?.dcNo}</td>
              <td className='text-left  table-data'>{getDateFromDateTimeToDisplay(item?.dcDate)}</td>
              <td className='text-right  table-data'>{item?.lotNo}</td>
              <td className='text-right  table-data'>{item?.inwardBags}</td>
              <td className='text-right  table-data'>{item?.inwardQty}</td>
            </tr>
          )
          }
          <tr className='table-row'>
            <td colSpan={5} className='table-data'></td>
            <td>Totals</td>
            <td className='text-right  table-data'>{sumArray(inwardItemsWithLot.filter(item => item.inwardBags), "inwardBags")}</td>
            <td className='text-right  table-data'>{sumArray(inwardItemsWithLot, "inwardQty")}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default YarnitemInwardReport
